<template>
  <div>
    <div class="table-tab__actions-block" v-if="editable">
      <table class="table-tab__block table">
        <thead class="table-tab__thead">
        <tr class="table-tab__row-auto-height">
          <th>{{$t('labels.actions')}}</th>
        </tr>
        </thead>
        <tbody class="table-tab__tbody">
        <template  v-for="(item, itemIdx) in specs">
          <tr class="table-tab__row-auto-height table-tab__tr">
            <template v-if="item.editable">
              <th class="table-tab__actions table-tab__actions--redaction u-align-items-start table-tab__border-top">
                <div class="table-tab__actions">
                  <button type="button" @click="onSaveChangesClick" :title="$t('buttons.save')">
                    <img class="table-tab__img-4" src="@/assets/img/static/tab-ok.svg" alt="">
                  </button>
                  <button type="button" @click="onDiscardChangesClick" :title="$t('buttons.cancel')">
                    <img class="table-tab__img-5" src="@/assets/img/static/tab-close.svg" alt="">
                  </button>
                </div>
              </th>
            </template>
            <template v-else>
              <th class="table-tab__actions table-tab__border-top" >
                <div class="table-tab__actions">
                  <button type="button" :title="$t('buttons.modify')" @click="onEditItemClick(itemIdx)">
                    <img class="table-tab__img-1" src="@/assets/img/static/b-icon_edit.svg" alt="">
                  </button>
                  <button type="button" :title="$t('buttons.copy')" @click="onCopyItemClick(itemIdx)">
                    <img class="table-tab__img-2" src="@/assets/img/static/b-icon_add-compare.svg" alt="">
                  </button>
                </div>
              </th>
            </template>
          </tr>

          <tr class="table-tab__row-auto-height table-tab__tr">
            <td class="table-tab__border-bottom"></td>
          </tr>
          <tr class="table-tab__row-auto-height table-tab__tr" v-if="item.state"></tr>

          <template v-for="(part, partId)  in item.parts">
            <tr class="table-tab__open table-tab__row-auto-height" v-if="item.editable || part.count > 0">
              <td class="table-tab__th"></td>
            </tr>
          </template>
        </template>
        </tbody>
      </table>
    </div>
    <div class="table-tab__container" style="overflow-x: auto">
      <table class="table-tab__block table " style="width: 1900px">
        <thead class="table-tab__thead">
          <tr class="table-tab__row-auto-height">
            <th colspan="2" class="table-tab__border-bottom table-tab__width-90 table-tab__th--row">№</th>
            <th class="table-tab__border-bottom" style="width: 25%;">{{$t('form.lot.specs.nomenclature')}}</th>
            <th class="table-tab__border-bottom" style="width: 18%;">{{$t('form.lot.specs.quantity')}}</th>
            <th class="table-tab__border-bottom">{{$t('form.lot.specs.unit')}}</th>
              <th class="table-tab__border-bottom" style="width: 20%;">{{$t('form.lot.specs.price-per-unit')}}</th>
            <th class="table-tab__border-bottom">{{$t('form.lot.specs.total-price')}}</th>
            <th class="table-tab__border-bottom">{{$t('form.lot.specs.bid-currency')}}</th>
            <th class="table-tab__border-bottom">{{$t('form.lot.specs.contract-currency')}}</th>
            <th class="table-tab__border-bottom">Валютная оговорка</th>
            <th class="table-tab__border-bottom table-tab__width-180"></th>
          </tr>
        </thead>
        <tbody class="table-tab__tbody">
        <template v-for="(item, i) in specs">
          <tr class="table-tab__row-auto-height"
              :class="{'declined-additional-spec-item': item.state && item.state.valueOf() === enums.AdditionalSpecItemState.DECLINED}">
            <!-- Открытие таба table-tab__btn-open-->
            <th class="table-tab__border-top" :class="{'table-tab__background-red': item.isAdditional}">
            </th>

            <th class="table-tab__border-top table-tab__th table-tab__th--row ">
  <!--              <img src="@/assets/img/static/arrow-up.png" alt="">-->
              {{item.serial}}
            </th>

            <td class="table-tab__border-top">
              <template v-if="!item.editable || (!item.isAdditional && !item.isNew)">
                {{item.catalog.name}}
              </template>
              <div class="a-form-field" v-else style="width: 180px">
                <categories-search full-search v-model="item.catalog" @input="onCategoryChange($event, item)"></categories-search>
              </div>
              <div v-if="item.request">
                <br>
                {{item.organization}}
                <router-link class="table-tab__color u-text-underline"
                             :to="{
                               name: 'purchases-public-lot-alien-bid',
                               params: {
                                 lotId: lotCatalog.id, requestId: item.request, bidId: 'num-' + item.bidNum, tab: 'bid'
                               }
                             }">
                  {{lotCatalog.num}} - {{item.request}} - {{item.bidNum}}
                </router-link>
              </div>
            </td>

            <td class="table-tab__border-top a-form-field ">
              <template v-if="!item.isAdditional">
                <template v-if="item.editable && !item.percent">
                  <div :class="{ 'a-input-group--error': $v.specs[i] && $v.specs[i].count.$dirty && $v.specs[i].count.$invalid }">
                    <input-float class="a-input table-tab__input-max-width-85"
                                 v-model="item.count">
                    </input-float>
                  </div>
                  <span class="a-validation-error" v-if="$v.specs[i] && $v.specs[i].count.$dirty && !$v.specs[i].count.required">{{$t('validation-error.mandatory-field-short')}}</span>
                  <span class="a-validation-error" v-if="$v.specs[i] && $v.specs[i].count.$dirty && !$v.specs[i].count.format">{{$t('validation-error.invalid-form-short')}}</span>
                  <span class="a-validation-error" v-if="$v.specs[i] && $v.specs[i].count.$dirty && !$v.specs[i].count.properParts">{{$t('validation-error.sum-differs-by', {value: item.dParts})}}</span>
                </template>

                <span v-else-if="!item.editable && !item.percent">{{item.count}}</span>
                <template v-else>
                  <div>{{item.count | percent}}%</div>
                </template>
              </template>

              <template v-else-if="item.isAdditional && item.parentPosition === 0">
                <label v-if="item.percent && item.editable">{{item.count | percent}}%</label>
                <input-float :value="item.count" @change="value => item.count = value" v-else-if="item.editable"></input-float>
                <label v-else>{{item.count}}</label>
              </template>

              <template v-else>
                <template v-if="item.multiplier">
                  {{item.count}} * {{item.multiplier}} = {{item.count * item.multiplier}}
                </template>
                <template v-else>
                  {{item.count}}
                </template>
              </template>
            </td>

            <td class="table-tab__border-top" colspan="7" v-if="item.dismiss">
            </td>

            <template v-if="!item.dismiss">
              <td class="table-tab__border-top" v-if="!item.dismiss">
                <template v-if="item.isAdditional">
                  <label>{{item.percent ? '% процент': item.okeiName || 'из справочника' }}</label>
                </template>
                <template v-else>
                  {{item.percent ? '% процент' : item.okeiName || 'из справочника'}}
                </template>
              </td>

              <td class="table-tab__border-top" v-if="item.editable && !item.isAdditional">
                <div :class="{ 'a-input-group--error': $v.specs.$each[i].price.$dirty && !$v.specs.$each[i].price.validPrice }">
                  <input-cost class="a-input table-tab__input-max-width-85"
                              :value="item.price"
                              @change="value => item.price = value"></input-cost>
                </div>
              </td>
              <td class="table-tab__border-top text-nowrap" v-else>{{item.price | price}}</td>

              <td class="table-tab__border-top text-nowrap">
                {{(item.price * (item.percent ? 1 : item.count) * (item.multiplier ? item.multiplier : 1)) | price}}
              </td>

              <td class="table-tab__border-top">
                <dropdown-new :options="enums.Currency.options.NOT_EMPTY"
                              placeholder="Любая"
                              multiple
                              v-model="item.bidCurrency"
                              v-if="item.editable">
                </dropdown-new>
                <span v-else>{{item.bidCurrency.map(e => $t(e.label)) | fullList}}</span>
              </td>

              <td class="table-tab__border-top">
                <dropdown-new :options="enums.Currency.options.NOT_EMPTY"
                              placeholder="Любая"
                              multiple
                              v-model="item.payCurrency"
                              v-if="item.editable">
                </dropdown-new>
                <span v-else>{{item.payCurrency.map(e => $t(e.label)) | fullList}}</span>
              </td>

              <td class="table-tab__border-top">
                <dropdown-new class="select-w-180"
                              :options="enums.CurrencyClauseOptional.options.all"
                              v-model="item.currencyClause"
                              v-if="item.editable">
                </dropdown-new>
                <span v-else>{{$t(item.currencyClause.label)}}</span>
              </td>
            </template>

            <td class="table-tab__border-top table-tab__width-180"></td>
          </tr>

          <tr class="table-tab__row-auto-height"
              :class="{'declined-additional-spec-item': item.state && item.state.valueOf() === enums.AdditionalSpecItemState.DECLINED}">
            <th  :class="{'table-tab__background-red': item.isAdditional}">
            </th>

            <!-- Открытие таба table-tab__btn-open-->
            <th class="table-tab__th table-tab__th--row table-tab__btn-open">
            </th>

            <td colspan="9" v-if="item.dismiss"></td>
            <template v-else>
              <td class="table-tab__border-bottom" colspan="5" >
                <label class="a-textarea a-textarea--disabled" v-if="item.isAdditional">{{item.additionalNomenclature}}</label>
              </td>

              <td class="table-tab__border-bottom" colspan="4">
              </td>
            </template>

            <td class="table-tab__border-bottom" colspan="1"></td>
          </tr>

          <tr class="table-tab__row-auto-height" v-if="item.state">
            <th :class="{'table-tab__background-red': item.isAdditional}">
            </th>

            <!-- Открытие таба table-tab__btn-open-->
            <th class="table-tab__th table-tab__th--row table-tab__btn-open">
            </th>

            <td colspan="8">
              <template v-if="item.permissions.CAN_APPROVE_SPEC_POSITION_IN_BID || item.permissions.CAN_DECLINE_SPEC_POSITION_IN_BID">
                <div class="a-input-group">
                  <dropdown-new class="select-w-260"
                                :options="[
                                  {
                                    id: enums.AdditionalSpecItemState.NONE,
                                    name: enums.AdditionalSpecItemState.label('NONE')
                                  },
                                  {
                                    id: enums.AdditionalSpecItemState.APPROVED,
                                    name: enums.AdditionalSpecItemState.label('APPROVED'),
                                    disabled: !item.permissions.CAN_APPROVE_SPEC_POSITION_IN_BID
                                  },
                                  {
                                    id: enums.AdditionalSpecItemState.DECLINED,
                                    name: enums.AdditionalSpecItemState.label('DECLINED'),
                                    disabled: !item.permissions.CAN_DECLINE_SPEC_POSITION_IN_BID
                                  },
                              ]"
                                v-model="item.state"></dropdown-new>
                  <button class="gui-btn gui-btn--red u-margin-left-20"
                          @click.prevent="onApproveAdditionalSpecItemClick(item)">Сохранить</button>
                </div>
                <textarea class="a-textarea u-margin-top-13"
                          placeholder="Причина"
                          v-model="item.reason"
                          v-if="item.state.valueOf() === enums.AdditionalSpecItemState.DECLINED">
                </textarea>
              </template>
              <template v-else-if="item.state.valueOf() === enums.AdditionalSpecItemState.NONE">
                <label><b>Статус:</b> Будет рассмотрена организатором</label>
              </template>
              <template v-else>
                <label><b>Статус:</b> {{$t(item.state.label)}}</label>
                <p><b>Причина:</b> {{item.reason}}</p>
              </template>

            </td>

            <td class="table-tab__border-bottom" colspan="2"></td>
          </tr>

          <template v-for="(part, partId) in item.parts">
            <tr class="table-tab__open table-tab__row-auto-height" v-if="item.editable || part.count > 0">
              <th class="table-tab__width-90 table-tab__th--row" colspan="2"></th>
              <td class="">
                <label class="a-checkbox__label " :class="{'a-checkbox__label--disable': !item.editable || item.parts[partId].count === 0}">
                  <input class="a-checkbox__input" type="checkbox" :disabled="!item.editable || item.parts[partId].count === 0" :checked="item.parts[partId].count > 0">
                  <span class="a-checkbox__icon"><i></i></span>
                  <span class="a-checkbox__text">{{$t('form.lot.parts.part-number', {id: item.parts[partId].serial})}}</span>
                </label>
              </td>

              <td v-if="item.editable && !item.isAdditional">
                <input-percent class="a-input table-tab__input-max-width-85"
                               v-model="item.parts[partId].count"
                               v-if="item.percent">
                </input-percent>
                <input-float class="a-input table-tab__input-max-width-85"
                             v-model="item.parts[partId].count"
                             v-else>
                </input-float>
              </td>
              <td v-else>
                <span v-if="item.percent">{{part.count | percent}}</span>
                <span v-else>{{part.count * (item.multiplier ? item.multiplier : 1)}}</span>
              </td>

              <td v-if="item.percent">%</td>
              <td v-else>{{item.okeiName}}</td>

              <td colspan="9"></td>
            </tr>
          </template>
        </template>
        </tbody>
      </table>
    </div>
    <div class="table-tab__btn-end" v-if="editable">
      <button @click="onAddItemClick" type="button" :disabled="hasEditable">
        <img src="@/assets/img/static/b-icon_plus-str.svg" alt="">
        {{$t('buttons.add-position-to-specification')}}
      </button>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import { required, decimal } from '@/validators'
  import { create, all } from 'mathjs'
  import CategoriesSearch from '@/components/common/inputs/CategoriesSearch'

  const math = create(all, {
    number: 'Fraction'
  });

  export default {
    components: {
      CategoriesSearch
    },

    props: {
      lotCatalog: {
        type: Object,
        required: true
      },

      specs: {
        type: Array,
        required: true
      },

      numberOfParts: {
        type: Number,
        required: true
      },

      editable: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      hasEditable: null,
      backup: undefined
    }),

    validations() {
      const rules = {
        specs: {
          $each: {
            price: {

            }
          }
        },
      };

      if (this.hasEditable) {
        rules.specs[this.hasEditable.index] = {
            count: {
              required,
              format: decimal,
              properParts: (value, item) => {
                const itemCount = math.fraction(value || 0);

                const partsSum = item.parts.reduce((acc, e) => {
                  const v = math.fraction(e.count || 0);
                  return acc.add(v);
                }, math.chain(0)).done();

                item.dParts = math.format(math.abs(math.subtract(itemCount, partsSum)), { fraction: 'decimal' });

                return math.equal(itemCount, partsSum);
              }
            }
          }
      }

      return rules;
    },

    mounted() {
      this._updateTableRowsHeight();
    },

    updated() {
      this._updateTableRowsHeight();
    },

    methods: {
      _updateTableRowsHeight() {
        const dataRows = $(this.$el).find('.table-tab__container .table-tab__row-auto-height');
        const controlRows = $(this.$el).find('.table-tab__actions-block .table-tab__row-auto-height');

        if (dataRows.length !== controlRows.length) {
          console.error('amount of data and control rows should be the same');
          return;
        }

        for (let i = 0; i < dataRows.length; ++i) {
          const $d = $(dataRows[i]);
          const $c = $(controlRows[i]);

          const height = Math.max($d.height(), $c.height());

          $d.height(height);
          $c.height(height);
        }
      },

      onSaveChangesClick() {
        this.$v.$touch();
        if (this.$v.$invalid) return;

        const specs = _.cloneDeep(this.specs);
        this.onDiscardChangesClick();

        this.$emit('update', specs);
      },

      onDiscardChangesClick() {
        if (this.hasEditable.backup) {
          this.$set(this.specs, this.hasEditable.index, this.hasEditable.backup);
        }
        else {
          this.specs.splice(this.hasEditable.index, 1);
        }

        this.hasEditable = null;
      },

      onEditItemClick(index) {
        if (this.hasEditable) return;

        this.hasEditable = {
          index,
          backup: _.cloneDeep(this.specs[index])
        };

        this.$set(this.specs[index], 'editable', true);
      },

      onCopyItemClick(index) {
        return;

        if (this.hasEditable) {
          return
        }

        this.hasEditable = { index: this.specs.length };
        const item = _.cloneDeep(this.specs[index]);
        this.specs.push(item);
      },

      onCategoryChange(event, item) {
        item.okei = event.okeiId;
        item.okeiName = event.okeiName;
      },

      onAddItemClick() {
        if (this.hasEditable) {
          return
        }

        this.hasEditable = { index: this.specs.length };

        this.specs.push({
          editable: true,
          isNew: true,
          catalog: {
            id: undefined,
            name: undefined
          },
          percent: false,
          count: undefined,
          okei: undefined,
          price: undefined,
          bidCurrency: [],
          payCurrency: [],
          currencyClause: new this.enums.CurrencyClauseOptional(this.enums.CurrencyClauseOptional.NOT_SET),
          parts: Array.from({
            length: this.numberOfParts
          }, (v, i) => ({
            part: i + 1,
            serial: i + 1,
            count: 0
          }))
        });
      },
    }
  }
</script>

<style scoped>

</style>
